import { connect } from 'react-redux';
import ResultPage from './ResultPage';
import { getMetricsForTags } from '../../reducers';
import { getTagsFromPath } from '../../helpers';

const mapStateToProps = (state, ownProps) => {
  const { location: { pathname } } = ownProps;

  const tags = getTagsFromPath(pathname);
  const metrics = getMetricsForTags(state.metrics, tags);

  return {
    metrics,
  };
};

const ResultPageConnector = connect(
  mapStateToProps,
)(ResultPage);

export default ResultPageConnector;


// WEBPACK FOOTER //
// ./src/components/result-page/ResultPageConnector.js